import { useEffect } from 'react';

const DynamicClubStyles = ({ clubSettings }) => {
  useEffect(() => {
    if (clubSettings) {
      createDynamicStyles(clubSettings);
    }
  }, [clubSettings]);

  const createDynamicStyles = (settings) => {
    const primaryColor = settings.primary_color || '#ea580c';
    const secondaryColor = settings.secondary_color || '#ffffff';
    const clubName = settings.club_name || 'النادي';
    
    // إزالة الأنماط السابقة إن وجدت
    const existingStyles = document.getElementById('dynamic-club-styles');
    if (existingStyles) {
      existingStyles.remove();
    }
    
    // إنشاء أنماط ديناميكية جديدة
    const styleElement = document.createElement('style');
    styleElement.id = 'dynamic-club-styles';
    
    styleElement.textContent = `
      /* ألوان النادي الديناميكية */
      :root {
        --club-primary: ${primaryColor};
        --club-secondary: ${secondaryColor};
        --club-primary-dark: ${darkenColor(primaryColor, 0.1)};
        --club-primary-light: ${lightenColor(primaryColor, 0.1)};
        --club-primary-50: ${addOpacity(primaryColor, 0.1)};
        --club-primary-100: ${addOpacity(primaryColor, 0.2)};
      }
      
      /* تطبيق الألوان على العناصر */
      .bg-orange-600, .bg-orange-500 {
        background-color: ${primaryColor} !important;
      }
      
      .text-orange-600, .text-orange-500 {
        color: ${primaryColor} !important;
      }
      
      .border-orange-600, .border-orange-500 {
        border-color: ${primaryColor} !important;
      }
      
      .hover\\:bg-orange-700:hover {
        background-color: ${darkenColor(primaryColor, 0.1)} !important;
      }
      
      .hover\\:text-orange-600:hover {
        color: ${primaryColor} !important;
      }
      
      /* أزرار النادي */
      .btn-primary {
        background: linear-gradient(135deg, ${primaryColor}, ${darkenColor(primaryColor, 0.1)});
        color: ${secondaryColor};
        border: none;
      }
      
      .btn-primary:hover {
        background: linear-gradient(135deg, ${darkenColor(primaryColor, 0.1)}, ${darkenColor(primaryColor, 0.2)});
        transform: translateY(-1px);
        box-shadow: 0 4px 12px ${addOpacity(primaryColor, 0.3)};
      }
      
      /* شريط التقدم والعناصر التفاعلية */
      .progress-bar {
        background-color: ${primaryColor} !important;
      }
      
      /* روابط النادي */
      .club-link {
        color: ${primaryColor} !important;
      }
      
      .club-link:hover {
        color: ${darkenColor(primaryColor, 0.1)} !important;
      }
      
      /* خلفيات متدرجة */
      .club-gradient {
        background: linear-gradient(135deg, ${primaryColor}, ${lightenColor(primaryColor, 0.2)});
      }
      
      .club-gradient-light {
        background: linear-gradient(135deg, ${addOpacity(primaryColor, 0.1)}, ${addOpacity(primaryColor, 0.05)});
      }
      
      /* ظلال النادي */
      .club-shadow {
        box-shadow: 0 4px 20px ${addOpacity(primaryColor, 0.2)} !important;
      }
      
      .club-shadow-lg {
        box-shadow: 0 8px 30px ${addOpacity(primaryColor, 0.3)} !important;
      }
      
      /* حلقات وحدود */
      .club-ring {
        --tw-ring-color: ${addOpacity(primaryColor, 0.3)} !important;
      }
      
      /* إشعارات النادي */
      .notification-success {
        background: linear-gradient(135deg, #10B981, #059669);
        border-left: 4px solid ${primaryColor};
      }
      
      .notification-info {
        background: linear-gradient(135deg, ${addOpacity(primaryColor, 0.1)}, ${addOpacity(primaryColor, 0.05)});
        border-left: 4px solid ${primaryColor};
        color: ${darkenColor(primaryColor, 0.3)};
      }
      
      /* تخصيص الألوان للحالات المختلفة */
      .text-blue-600 {
        color: ${primaryColor} !important;
      }
      
      .bg-blue-600 {
        background-color: ${primaryColor} !important;
      }
      
      .border-blue-600 {
        border-color: ${primaryColor} !important;
      }
      
      /* شعار النادي ديناميكي */
      .club-logo-bg {
        background: linear-gradient(135deg, ${primaryColor}, ${secondaryColor === '#ffffff' ? darkenColor(primaryColor, 0.2) : secondaryColor});
      }
      
      /* تحديثات خاصة بالنادي */
      .club-branding::before {
        content: "${clubName}";
        font-weight: bold;
        color: ${primaryColor};
      }
    `;
    
    document.head.appendChild(styleElement);
    
    console.log(`🎨 تم تطبيق الأنماط الديناميكية للنادي: ${clubName}`);
    console.log(`🎯 اللون الأساسي: ${primaryColor}, اللون الثانوي: ${secondaryColor}`);
  };

  // مساعدات الألوان
  const darkenColor = (color, amount) => {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(255 * amount);
    const R = Math.max(0, (num >> 16) - amt);
    const G = Math.max(0, (num >> 8 & 0x00FF) - amt);
    const B = Math.max(0, (num & 0x0000FF) - amt);
    return '#' + ((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1);
  };

  const lightenColor = (color, amount) => {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(255 * amount);
    const R = Math.min(255, (num >> 16) + amt);
    const G = Math.min(255, (num >> 8 & 0x00FF) + amt);
    const B = Math.min(255, (num & 0x0000FF) + amt);
    return '#' + ((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1);
  };

  const addOpacity = (color, opacity) => {
    const num = parseInt(color.replace('#', ''), 16);
    const R = num >> 16;
    const G = num >> 8 & 0x00FF;
    const B = num & 0x0000FF;
    return `rgba(${R}, ${G}, ${B}, ${opacity})`;
  };

  return null;
};

export default DynamicClubStyles;